import { FC, useEffect } from "react";
import { Box } from "@mui/material";
import "@xyflow/react/dist/style.css";
import { useForm, FormProvider } from "react-hook-form";
import { standardSchemaResolver } from "@hookform/resolvers/standard-schema";
import { useLocation, useParams } from "react-router-dom";
import OrgChartContext from "src/Pages/Company/OrganizationStructure/context/OrgchartContext";
import useOrgchartAreasStore from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/Areas/store";
import useOrgchartEmployeesStore from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/Employees/store";
import changeNodesVisibility from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/Areas/changeNodesVisibility";
import EmployeesOrgchartDataProvider from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/Employees/EmployeesOrgchartDataProvider";
import {
  IOrgchartViewQueryParams,
  OrgchartType,
} from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/FilterBar.models";
import { FilterBarSchema } from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/FilterBar.scheme";
import AreasOrgchartDataProvider from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/Areas/AreasOrgchartDataProvider";

interface QueryData {
  companyId: string;
  structureId: string;
}

const StructureView: FC<QueryData> = ({ structureId, companyId }) => {
  const location = useLocation();
  const { orgchartType, nodeId } = useParams() as {
    orgchartType: OrgchartType;
    nodeId: string | undefined;
  };

  const FilterBarDefaultValues: IOrgchartViewQueryParams = {
    autocomplete: "",
    orgChartType: orgchartType,
  };

  const methods = useForm<IOrgchartViewQueryParams>({
    resolver: standardSchemaResolver(FilterBarSchema),
    defaultValues: FilterBarDefaultValues,
  });

  useEffect(() => {
    useOrgchartAreasStore.setState(useOrgchartAreasStore.getInitialState());
    useOrgchartEmployeesStore.setState(
      useOrgchartEmployeesStore.getInitialState()
    );
    if (nodeId && orgchartType === OrgchartType.Employees) {
      useOrgchartEmployeesStore.getState().setSearchedNodeId(nodeId);
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  return (
    <OrgChartContext.Provider value={{ changeNodesVisibility }}>
      <FormProvider {...methods}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          {orgchartType === OrgchartType.Areas ? (
            <AreasOrgchartDataProvider
              companyId={companyId}
              structureId={structureId}
            />
          ) : (
            <EmployeesOrgchartDataProvider
              companyId={companyId}
              structureId={structureId}
            />
          )}
        </Box>
      </FormProvider>
    </OrgChartContext.Provider>
  );
};

export default StructureView;
